import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import { CookieBanner } from "@/components/CookieBanner";
import { LanguageHint } from "@/components/LanguageHint";
import { LanguageProvider } from "@/i18n/LanguageProvider";

import LandingPage from "@/pages/LandingPage";
import HomePage from "@/pages/HomePage";
import WohnungenPage from "@/pages/WohnungenPage";
import ArchitekturPage from "@/pages/ArchitekturPage";
import KontaktPage from "@/pages/KontaktPage";
import InvestorPage from "@/pages/InvestorPage";
import VermoegensaufbauPage from "@/pages/VermoegensaufbauPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

const RequireAuth = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading || user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-cream">
                <div className="text-stone-500 font-body" data-testid="auth-loading">Lade…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
};

function App() {
    return (
        <div className="App">
            <HelmetProvider>
                <LanguageProvider>
                    <AuthProvider>
                        <BrowserRouter>
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/wohnungen" element={<WohnungenPage />} />
                                <Route path="/wohnung/:slug" element={<WohnungenPage />} />
                                <Route path="/architektur" element={<ArchitekturPage />} />
                                <Route path="/kontakt" element={<KontaktPage />} />
                                <Route path="/investor" element={<InvestorPage />} />
                                <Route path="/vermoegensaufbau" element={<VermoegensaufbauPage />} />
                                <Route path="/legacy" element={<LandingPage />} />
                                <Route path="/impressum" element={<Impressum />} />
                                <Route path="/datenschutz" element={<Datenschutz />} />
                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route
                                    path="/admin"
                                    element={
                                        <RequireAuth>
                                            <AdminDashboard />
                                        </RequireAuth>
                                    }
                                />
                                <Route path="*" element={<Navigate to="/" replace />} />
                            </Routes>
                            <CookieBanner />
                            <LanguageHint />
                        </BrowserRouter>
                        <Toaster richColors position="top-right" />
                    </AuthProvider>
                </LanguageProvider>
            </HelmetProvider>
        </div>
    );
}

export default App;
